import React, { useState } from 'react';
import {
  useGetUiPreferencesQuery,
  useUpdateUiPreferencesMutation,
} from 'store/services/settings/uiPreferencesApi';
import './ShippingGuideBanner.css';

export default function ShippingGuideBanner() {
  const [localDismissed, setLocalDismissed] = useState(() => {
    return localStorage.getItem('shippingGuideBannerDismissed') === 'true';
  });

  const { data: prefs } = useGetUiPreferencesQuery(undefined, {
    skip: localDismissed,
  });
  const [updatePrefs] = useUpdateUiPreferencesMutation();

  const isDismissed = localDismissed || prefs?.shippingGuideBannerDismissed;

  if (isDismissed) return null;

  const handleDismiss = async () => {
    localStorage.setItem('shippingGuideBannerDismissed', 'true');
    setLocalDismissed(true);
    try {
      await updatePrefs({ shippingGuideBannerDismissed: true }).unwrap();
    } catch {
      // Banner stays dismissed locally even if API fails
    }
  };

  return (
    <div className="shipping-guide-banner">
      <div className="shipping-guide-banner-content">
        <svg className="shipping-guide-banner-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 16v-4M12 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
        <span className="shipping-guide-banner-text">
          New to shipping? Check out our{' '}
          <a
            href="https://trademagic.gg/articles/shipping"
            target="_blank"
            rel="noopener noreferrer"
          >
            Shipping Guide
          </a>
          {' '}and{' '}
          <a
            href="https://trademagic.gg/articles/condition-guide"
            target="_blank"
            rel="noopener noreferrer"
          >
            Condition Guide
          </a>
        </span>
      </div>
      <button
        className="shipping-guide-banner-dismiss"
        onClick={handleDismiss}
      >
        Dismiss
      </button>
    </div>
  );
}
